import React, { memo, useEffect, useMemo, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import '../../css/Table.css'; // Import the external CSS file
import ScrollContainer from "./ScrollContainer";
import TranslateFile from "../../Loc/TranslateFile";

const Table = ({
    title,
    columns,
    data,
    pagination = true,
    defaultSortField,
    defaultSortAsc = true,
    onSelectedRowsChange,
    conditionalRowStyles,
    subHeader,
    subHeaderComponent,
    paginationPerPage = 10,
    onChangeRowsPerPage,
    onChangePage,
    paginationRowsPerPageOptions = paginationPerPage == 5 ? [5, 10, 15, 20] : [10, 15, 20],
    currentPage,
    handleONCLick,
    totalRowCount,
    paginationServer = false,
    maxHeight = '560px',
    selectedrow = null,
    isSelectrow = false,
    isScrollContainer = false
}) => {
    const tableRef = useRef(null);
    const [showScrollButtons, setShowScrollButtons] = useState(false);
    const currentLang = TranslateFile();


    const checkScrollButtons = () => {
        if (tableRef.current) {
            const { scrollHeight, clientHeight } = tableRef.current;
            setShowScrollButtons(scrollHeight > clientHeight);
        }
    };

    useEffect(() => {
        checkScrollButtons(); // Initial check
        window.addEventListener('resize', checkScrollButtons); // Check on resize

        return () => {
            window.removeEventListener('resize', checkScrollButtons);
        };
    }, []);

    useEffect(() => {
        checkScrollButtons(); // Check whenever the page changes
    }, [currentPage, data]);

    const handlePaginationChange = () => {
        checkScrollButtons(); // Recheck scroll button visibility after page change
    };
    const memoizedColumns = useMemo(() => columns, [columns]);
    const memoizedData = useMemo(() => data, [data]);

    return (
        // <ScrollContainer>
        // <div className="table-wrapper" ref={tableRef} style={{ maxHeight: '79vh', overflowY: 'auto' }}>
        <div className="table-wrapper" ref={tableRef} style={{ overflowY: 'auto' }}>
            {isScrollContainer ?
                <ScrollContainer>
                    <DataTable
                        title={title}
                        className="table-responsive"
                        columns={memoizedColumns}
                        data={memoizedData}
                        pagination={pagination}
                        paginationPerPage={paginationPerPage}
                        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                        onChangeRowsPerPage={paginationServer ? onChangeRowsPerPage : handlePaginationChange}
                        onChangePage={onChangePage}
                        paginationTotalRows={totalRowCount}
                        paginationDefaultPage={currentPage}
                        paginationServer={paginationServer}
                        onRowClicked={handleONCLick}
                        conditionalRowStyles={[
                            {
                                when: (row) => (isSelectrow && row.PUIConnectionID === selectedrow?.PUIConnectionID),  // Compare the PUIConnectionID
                                style: {
                                    backgroundColor: 'red',
                                    fontWeight: 'bold',
                                    color: '#3c763d'
                                }
                            }
                        ]}
                        responsive={true}
                    />
                    {(!pagination) && (
                        <p className="fs-5 mt-2">{currentLang?.Total_Records} {totalRowCount}</p>
                    )}
                </ScrollContainer> :
                <div className="mt-1">
                    <DataTable
                        title={title}
                        className="table-responsive"
                        columns={memoizedColumns}
                        data={memoizedData}
                        pagination={pagination}
                        paginationPerPage={paginationPerPage}
                        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                        onChangeRowsPerPage={paginationServer ? onChangeRowsPerPage : handlePaginationChange}
                        onChangePage={onChangePage}
                        paginationTotalRows={totalRowCount}
                        paginationDefaultPage={currentPage}
                        paginationServer={paginationServer}
                        onRowClicked={handleONCLick}
                        responsive={true}
                    />
                    {(!pagination) && (
                        <p className="fs-5 mt-2">{currentLang?.Total_Records} {totalRowCount}</p>
                    )}
                </div>
            }
        </div>
        // </ScrollContainer>
    );
};

export default memo(Table);
